{
  "el": {
    "locale_field": {
      "fallback_tooltip": "Όταν δεν έχει συμπληρωθεί κείμενο για αυτή τη γλώσσα, θα χρησιμοποιηθεί αυτό το προεπιλεγμένο κείμενο.",
      "fill_missing": "Συμπλήρωση γλώσσας που λείπει ({count}) | Συμπλήρωση γλωσσών που λείπουν ({count})",
      "fill_missing_budget_used": "Ο προϋπολογισμός AI αυτού του μήνα εξαντλήθηκε.",
      "fill_missing_done": "Οι γλώσσες που έλειπαν συμπληρώθηκαν. Έλεγξε το κείμενο πριν την αποθήκευση.",
      "fill_missing_errors": {
        "budget_reached": "Ο προϋπολογισμός AI αυτού του μήνα εξαντλήθηκε. Επικοινώνησε με τη Ziggu για να τον αυξήσεις.",
        "generic": "Οι γλώσσες δεν μπόρεσαν να συμπληρωθούν. Δοκίμασε ξανά.",
        "too_long": "Αυτό το κείμενο είναι πολύ μεγάλο για να μεταφραστεί με μία φορά."
      },
      "fill_missing_tooltip": "Μεταφράζει από {language} με AI. Έλεγξε το κείμενο πριν την αποθήκευση.",
      "translated_in": "Μεταφρασμένο σε"
    }
  }
}
